export function truncateText(comment, length = 100) {

    const maxLength = length;

    const originalText = comment?.originalText || comment?.text || comment;
    return originalText.length > maxLength ? originalText.slice(0, maxLength) + '...' : originalText;
  }